import Embed from "editor/components/Embed/Embed.js";
import PlainQuote from "editor/components/PlainQuote/PlainQuote.js";
import Image from "editor/components/Image/Image.js";
import KeepReading from "editor/components/KeepReading/KeepReading.js";
import QuoteAttribution from "editor/components/QuoteAttribution";
import Axiom from "editor/components/Axiom";

import { BLOCK_TYPE } from "config/constants/editor";

export default function blockRendererFn(contentBlock) {
  const type = contentBlock.getType();

  switch (type) {
    case BLOCK_TYPE.PLAIN_QUOTE:
      return {
        component: PlainQuote,
        text: "",
      };
    case BLOCK_TYPE.EMBED:
      return {
        component: Embed,
        text: "",
      };
    case BLOCK_TYPE.IMAGE:
      return {
        component: Image,
        text: "",
      };
    case BLOCK_TYPE.KEEP_READING:
      return {
        component: KeepReading,
        editable: false,
        text: "",
      };
    case BLOCK_TYPE.QUOTE_ATTRIBUTION:
      return {
        component: QuoteAttribution,
        text: "",
      };
    case BLOCK_TYPE.AXIOM:
      return {
        component: Axiom,
        text: "",
      };
    default:
      return undefined;
  }
}
